import * as z from 'zod';

import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';

import { productAndServiceTemplateQueryLinkerSchema } from './products-and-services-template-query-linker-schema';

import { productAndServicesTemplateItemQuerySchema } from '../products-and-services-template-item';

export const productAndServiceTemplateQuerySchema = z.object({
  ...productAndServiceTemplateQueryLinkerSchema.shape,
  description: z.string(),
  product_template_items: z.array(productAndServicesTemplateItemQuerySchema).nullable(),
});

export type ProductAndServiceTemplateQuerySchema = z.infer<typeof productAndServiceTemplateQuerySchema>;

export const productAndServiceTemplateQueryAllSchema = paginatedResponseSchema(productAndServiceTemplateQuerySchema);

export type ProductAndServiceTemplateQueryAllSchema = z.infer<typeof productAndServiceTemplateQueryAllSchema>;
